import { IFormService } from "../../service/form/FormService";

export default class ValidateFormInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formId: number) {
    return this.formService.validateForm(formId);
  }
}
